import axios from "axios";
const carousel = {
    boot: function () {
        const createCarousel = function(selector, options = {}) {
            let {
                images = [],
                onMove = (changed) => {},
                onDelete = (id) => {},
                initialHeight = 200,
                initialSpeed = 10,
                initialDirection = 'left',
                enableDrag = true,
                enableZoom = true,
                enableEdit = true,
                enableStopOnHover = true,
                enableEdgeBlur = false,
                uploadUrl = '',
                getUrl = '',
                sortUrl = '',
                deleteURL = '',
                settingsUrl = ''
            } = options;
            let startX;
            let idCounter = images.length + 1;
            let tempIdCounter = -1;
            const carousel = document.querySelector(selector);
            if (!carousel) {
                return;
            }
            const track = document.createElement('div');
            track.classList.add('track');
            carousel.appendChild(track);
            let currentHeight = initialHeight;
            let currentDuration = initialSpeed;
            let groupWidth = 0;
            let localImages = images.map((item, index) => ({
                id: item.id || idCounter++,
                picture: item.picture,
                position: index + 1
            }));
            localImages.sort((a, b) => a.position - b.position);
            let currentDirection = initialDirection;
            let dragEnabled = enableDrag;
            let zoomEnabled = enableZoom;
            let editEnabled = enableEdit;
            let wasRunning = false;
            let isDragging = false;
            let isDeleting = false;
            let stopOnHover = enableStopOnHover;
            let edgeBlur = enableEdgeBlur;
            let animationRunning = true;
            let didDrag = false;

            function pauseBtnText() {
                const pauseBtn = document.querySelector('.carousel-pause');
                if (pauseBtn) {
                    pauseBtn.textContent = animationRunning ? 'Пауза' : 'Запустить';
                }
            }
            function updatePositions(localImages) {
                localImages.forEach((item, index) => {
                    item.position = index + 1;
                });
            }
            function setupDrag() {
                carousel.addEventListener('mousedown', (e) => {
                    if (dragEnabled) {
                        isDragging = true;
                        startX = e.clientX;
                        wasRunning = animationRunning;
                        pause();
                        // track.style.animationName = 'ease';
                        // track.style.animationPlayState = 'running';
                        // Preserve current transform as inline before disabling animation
                        const computed = window.getComputedStyle(track).transform;
                        let currentOffset = computed !== 'none' ? new DOMMatrix(computed).m41 : 0;
                        track.style.transform = `translateX(${currentOffset}px)`;
                        track.style.animation = 'none';
                        e.preventDefault();
                    }
                });
                carousel.addEventListener('mousemove', (e) => {
                    if (dragEnabled && isDragging) {
                        didDrag = true;
                        const delta = e.clientX - startX;
                        const computed = window.getComputedStyle(track).transform;
                        let currentOffset = computed !== 'none' ? new DOMMatrix(computed).m41 : 0;
                        currentOffset += delta;
                        track.style.transform = `translateX(${currentOffset}px)`;
                        startX = e.clientX;
                        e.preventDefault();
                    }
                });
                carousel.addEventListener('mouseup', () => {
                    if (dragEnabled && isDragging) {
                        isDragging = false;
                        if (wasRunning) {
                            play();
                        }
                    }
                });
                carousel.addEventListener('mouseleave', () => {
                    if (dragEnabled && isDragging) {
                        isDragging = false;
                        if (wasRunning) {
                            play();
                        }
                    }
                });
                // Touch events
                carousel.addEventListener('touchstart', (e) => {
                    if (dragEnabled) {
                        isDragging = true;
                        startX = e.touches[0].clientX;
                        wasRunning = animationRunning;
                        pause();
                        // track.style.animationName = 'ease';
                        // track.style.animationPlayState = 'running';
                        // Preserve current transform as inline before disabling animation
                        const computed = window.getComputedStyle(track).transform;
                        let currentOffset = computed !== 'none' ? new DOMMatrix(computed).m41 : 0;
                        track.style.transform = `translateX(${currentOffset}px)`;
                        track.style.animation = 'none';
                        e.preventDefault();
                    }
                });
                carousel.addEventListener('touchmove', (e) => {
                    if (dragEnabled && isDragging) {
                        didDrag = true;
                        const delta = e.touches[0].clientX - startX;
                        const computed = window.getComputedStyle(track).transform;
                        let currentOffset = computed !== 'none' ? new DOMMatrix(computed).m41 : 0;
                        currentOffset += delta;
                        track.style.transform = `translateX(${currentOffset}px)`;
                        startX = e.touches[0].clientX;
                        e.preventDefault();
                    }
                });
                carousel.addEventListener('touchend', () => {
                    if (dragEnabled && isDragging) {
                        isDragging = false;
                        if (wasRunning) {
                            play();
                        }
                    }
                });
            }
            if (dragEnabled) {
                setupDrag();
            }
            function updateAnimation() {
                if (groupWidth === 0 || localImages.length === 0) return;
                // Get current offset
                const computed = window.getComputedStyle(track).transform;
                let currentOffset = computed !== 'none' ? new DOMMatrix(computed).m41 : 0;
                // Positive modulo to handle negative values
                let modOffset = ((currentOffset % groupWidth) + groupWidth) % groupWidth;
                // Normalize to [-groupWidth, 0]
                currentOffset = modOffset - groupWidth;
                // Preserve position
                track.style.animation = 'none';
                track.style.transform = `translateX(${currentOffset}px)`;
                track.offsetHeight; // Reflow
                document.documentElement.style.setProperty('--group-width', `${groupWidth}px`);
                const keyframeName = currentDirection === 'left' ? 'slide-left' : 'slide-right';
                // Calculate progress and delay for seamless start
                let progress;
                if (currentDirection === 'left') {
                    progress = -currentOffset / groupWidth;
                } else {
                    progress = (groupWidth + currentOffset) / groupWidth;
                }
                const delay = -progress * currentDuration;
                track.style.animation = `${keyframeName} ${currentDuration}s linear infinite`;
                track.style.animationDelay = `${delay}s`;
                track.style.animationPlayState = animationRunning ? 'running' : 'paused';
            }
            let group1, group2;
            function buildGroups() {
                group1 = document.createElement('div');
                group1.classList.add('group');
                group2 = document.createElement('div');
                group2.classList.add('group');
                group2.setAttribute('aria-hidden', 'true');
                localImages.forEach(item => {
                    group1.appendChild(createCard(item));
                    group2.appendChild(createCard(item));
                });
                track.appendChild(group1);
                track.appendChild(group2);
            }
            function rebuildGroups() {
                track.innerHTML = '';
                buildGroups();
                setTimeout(() => {
                    groupWidth = group1?.offsetWidth || 0;
                    updateAnimation();
                }, 600);
            }
            function createCard(item, isUploaded = false) {
                const card = document.createElement('div');
                card.classList.add('card');
                card.dataset.id = item.id;
                const img = document.createElement('img');
                img.src = item.picture;
                img.alt = '';
                img.style.height = isUploaded ? `1px` : `${currentHeight}px`;
                img.loading = 'lazy';
                card.appendChild(img);
                card.addEventListener('click', (e) => {
                    if (didDrag) {
                        didDrag = false;
                        return;
                    }
                    if (!e.target.closest('button')) {
                        openPopup(item.picture);
                    }
                });
                card.addEventListener('mouseenter', () => {
                    wasRunning = animationRunning;
                    if (zoomEnabled && !isDeleting) {
                        img.style.height = `${currentHeight * 1.2}px`;
                    }
                    if (stopOnHover) {
                        pause();
                        pauseBtnText();
                    }
                });
                card.addEventListener('mouseleave', () => {
                    if (zoomEnabled && !isDeleting) {
                        img.style.height = `${currentHeight}px`;
                    }
                    if (stopOnHover && wasRunning) {
                        play();
                        pauseBtnText();
                    }
                });
                if (editEnabled) {
                    const moveLeft = document.createElement('button');
                    moveLeft.classList.add('move-left');
                    moveLeft.innerHTML = '<svg class="icon" viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>';
                    //moveLeft.style.display = 'flex';
                    moveLeft.onclick = () => moveCard(item.id, 'left');
                    card.appendChild(moveLeft);
                    const moveRight = document.createElement('button');
                    moveRight.classList.add('move-right');
                    moveRight.innerHTML = '<svg class="icon" viewBox="0 0 24 24"><path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z"/></svg>';
                    //moveRight.style.display = 'flex';
                    moveRight.onclick = () => moveCard(item.id, 'right');
                    card.appendChild(moveRight);
                    const deleteBtn = document.createElement('button');
                    deleteBtn.classList.add('delete');
                    deleteBtn.innerHTML = '<svg class="icon" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>';
                    //deleteBtn.style.display = 'flex';
                    deleteBtn.onclick = () => deleteCard(item.id);
                    card.appendChild(deleteBtn);
                }
                return card;
            }
            function openPopup(src) {
                const overlay = document.createElement('div');
                overlay.style.position = 'fixed';
                overlay.style.top = '0';
                overlay.style.left = '0';
                overlay.style.width = '100%';
                overlay.style.height = '100%';
                overlay.style.background = 'rgba(0, 0, 0, 0.5)';
                overlay.style.zIndex = '1000';
                const popupImg = document.createElement('img');
                popupImg.src = src;
                popupImg.style.position = 'fixed';
                popupImg.style.top = '10vh';
                popupImg.style.left = '50%';
                popupImg.style.transform = 'translateX(-50%)';
                popupImg.style.height = '80vh';
                popupImg.style.width = 'auto';
                popupImg.style.objectFit = 'contain';
                popupImg.style.zIndex = '1001';
                document.body.appendChild(overlay);
                document.body.appendChild(popupImg);
                const popupWasRunning = animationRunning;
                pause();
                const closePopup = () => {
                    overlay.remove();
                    popupImg.remove();
                    if (popupWasRunning) {
                        play();
                    }
                };
                overlay.addEventListener('click', closePopup);
                popupImg.addEventListener('click', closePopup);
            }
            function insertNode(parent, newNode, index) {
                if (index === 0) {
                    parent.prepend(newNode);
                } else if (index >= parent.children.length) {
                    parent.appendChild(newNode);
                } else {
                    parent.insertBefore(newNode, parent.children[index]);
                }
            }
            async function moveCard(id, direction) {
                const index = localImages.findIndex(item => item.id === id);
                if (index === -1) return;
                const oldPositions = new Map(localImages.map(item => [item.id, item.position]));
                let adjacentIndex = direction === 'left' ? index - 1 : index + 1;
                if (adjacentIndex < 0 || adjacentIndex >= localImages.length) return;
                const adjacentId = localImages[adjacentIndex].id;
                const localWasRunning = animationRunning;
                pause(); // Остановить карусель на время анимации
                // Получить все элементы в group1 (для анимации; group2 дублирует)
                const elementsToAnimate = Array.from(group1.children); // Анимируем все для учета сдвигов
                // First: Получить начальные позиции
                const firstRects = elementsToAnimate.map(el => el.getBoundingClientRect());
                // Swap в массиве
                [localImages[index], localImages[adjacentIndex]] = [localImages[adjacentIndex], localImages[index]];
                updatePositions(localImages);
                // Swap в DOM для обеих групп
                [group1, group2].forEach(group => {
                    const cardNode = group.querySelector(`.card[data-id="${id}"]`);
                    const adjacentNode = group.querySelector(`.card[data-id="${adjacentId}"]`);
                    if (direction === 'left') {
                        group.insertBefore(cardNode, adjacentNode);
                    } else {
                        group.insertBefore(cardNode, adjacentNode.nextSibling);
                    }
                });
                // Last: Получить новые позиции
                const lastRects = elementsToAnimate.map(el => el.getBoundingClientRect());
                // Invert: Установить transform для компенсации сдвига (delta)
                elementsToAnimate.forEach((el, i) => {
                    const deltaX = firstRects[i].left - lastRects[i].left;
                    const deltaY = firstRects[i].top - lastRects[i].top;
                    const deltaW = firstRects[i].width / lastRects[i].width;
                    const deltaH = firstRects[i].height / lastRects[i].height;
                    el.dataset.flipKey = el.dataset.id || Date.now() + Math.random(); // Для tracking
                    el.style.transformOrigin = 'top left';
                    el.style.transition = 'none';
                    el.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(${deltaW}, ${deltaH})`;
                });
                // Force reflow с RAF для invert
                requestAnimationFrame(() => {
                    // Play: Анимировать к transform=''
                    elementsToAnimate.forEach((el) => {
                        el.style.transition = 'transform 0.3s ease';
                        el.style.transform = '';
                    });
                });
                // Ждать завершения анимации с transitionend
                await new Promise((resolve) => {
                    let completed = 0;
                    const onEnd = () => {
                        completed++;
                        if (completed === elementsToAnimate.length) {
                            resolve();
                        }
                    };
                    elementsToAnimate.forEach(el => {
                        el.addEventListener('transitionend', onEnd, { once: true });
                    });
                    // Fallback timeout
                    setTimeout(resolve, 400);
                });
                // Очистить стили
                elementsToAnimate.forEach(el => {
                    el.style.transition = '';
                    el.style.transform = '';
                    el.style.transformOrigin = '';
                    delete el.dataset.flipKey;
                });
                groupWidth = group1?.offsetWidth || 0;
                updateAnimation();
                if (localWasRunning) play();
                const changed = localImages.filter(item => oldPositions.get(item.id) !== item.position).map(item => ({id: item.id, position: item.position}));
                if (sortUrl) {
                    await axios.post(sortUrl, changed);
                }
                onMove(changed);
            }
            function deleteCard(id) {
                const index = localImages.findIndex(item => item.id === id);
                if (index === -1) return;
                const localWasRunning = animationRunning;
                pause();
                isDeleting = true;
                const cards = track.querySelectorAll(`.card[data-id="${id}"]`);
                cards.forEach(card => {
                    card.querySelector('img').style.height = '1px';
                });
                setTimeout(() => {
                    cards.forEach(card => {
                        card.remove();
                    });
                    localImages.splice(index, 1);
                    updatePositions(localImages);
                    groupWidth = group1?.offsetWidth || 0;
                    updateAnimation();
                    if (localWasRunning && localImages.length) play();
                    isDeleting = false;
                    if (deleteURL) {
                        axios.post(deleteURL, {id: id});
                    }
                    onDelete(id);
                }, 600);
            }
            async function uploadImages(newOnes) {
                const formData = new FormData();
                newOnes.forEach((n, i) => {
                    formData.append('images[]', n.file);
                    formData.append('positions[]', n.position);
                    formData.append('indexes[]', n.index);
                });
                try {
                    const response = await axios.post(uploadUrl, formData);
                    return await response.data || [];
                } catch (error) {
                    console.error('Ошибка загрузки:', error);
                    alert('Ошибка загрузки изображений.');
                    return [];
                }
            }
            async function addItems(items) {
                if (!group1 || !group2 || !items.length) return false;
                const localWasRunning = animationRunning;
                pause();
                // Preload images
                await Promise.all(items.map(item => new Promise(resolve => {
                    const img = new Image();
                    img.src = item.picture;
                    img.onload = resolve;
                    img.onerror = resolve; // Proceed even on error
                })));
                // Get current offset for insert position calculation (оставляем, но не используем в center)
                const computed = window.getComputedStyle(track).transform;
                let currentOffset = computed !== 'none' ? new DOMMatrix(computed).m41 : 0;
                const len = localImages.length;
                const viewportRect = carousel.getBoundingClientRect();
                const center = viewportRect.left + viewportRect.width / 2; // Убрали - currentOffset % groupWidth
                let allCards = Array.from(group1.children); // Use group1 for positions
                let arrayInsertIndex = len ? Math.floor(len / 2) : 0;
                let found = false;
                if (len > 0) {
                    for (let i = 0; i < allCards.length - 1; i++) {
                        const rect = allCards[i].getBoundingClientRect();
                        const nextRect = allCards[i + 1].getBoundingClientRect();
                        if (rect.right <= center && center <= nextRect.left) {
                            arrayInsertIndex = i + 1;
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        for (let i = 0; i < allCards.length; i++) {
                            const rect = allCards[i].getBoundingClientRect();
                            if (rect.left <= center && center < rect.right) {
                                const mid = rect.left + rect.width / 2;
                                arrayInsertIndex = i + (center < mid ? 0 : 1); // Вставка перед/после середины карточки
                                break;
                            }
                        }
                    }
                }
                arrayInsertIndex = Math.min(arrayInsertIndex, len);
                // Подстройка
                if (arrayInsertIndex > 1) {
                    arrayInsertIndex = arrayInsertIndex - 1;
                }
                const newItems = items.map((item, index) => ({
                    file: item.file,
                    position: 0,
                    index: index
                }));
                localImages.splice(arrayInsertIndex, 0, ...newItems);
                updatePositions(localImages);
                const added = await uploadImages(newItems);
                if (!added.length) {
                    return false;
                }
                const addedMap = new Map(added.map(item => [item.index, item]));
                newItems.forEach((item, index) => {
                    item.id = addedMap.get(index).id;
                    item.picture = addedMap.get(index).picture;
                    delete item.file;
                });
                const measuredWidths = await Promise.all(newItems.map(async item => {
                    const tempImg = new Image();
                    tempImg.src = item.picture;
                    await new Promise(res => tempImg.onload = res);
                    const aspect = tempImg.naturalWidth / tempImg.naturalHeight;
                    return aspect * currentHeight;
                }));
                const tempCards1 = newItems.map(item => createCard(item, true));
                const tempCards2 = newItems.map(item => createCard(item, true));
                for (let i = 0; i < tempCards1.length; i++) {
                    insertNode(group1, tempCards1[i], arrayInsertIndex + i);
                    insertNode(group2, tempCards2[i], arrayInsertIndex + i);
                }
                requestAnimationFrame(() => {
                    tempCards1.forEach((card, i) => card.style.width = `${measuredWidths[i]}px`);
                    tempCards2.forEach((card, i) => card.style.width = `${measuredWidths[i]}px`);
                });
                setTimeout(async () => {
                    groupWidth = group1?.offsetWidth || 0;
                    updateAnimation();
                    if (localWasRunning) play();
                    for (let i = 0; i < tempCards1.length; i++) {
                        tempCards1[i].querySelector('img').style.height = `${currentHeight}px`;
                    }
                    requestAnimationFrame(() => {
                        tempCards1.forEach((card, i) => card.style.width = `${measuredWidths[i]}px`);
                        tempCards2.forEach((card, i) => card.style.width = `${measuredWidths[i]}px`);
                    });
                }, 400);
                if (sortUrl) {
                    await axios.post(sortUrl, localImages.map(item => ({id: item.id, position: item.position})));
                }
                return true;
            }
            function addImage(url) {
                addItems([{picture: url}]);
            }
            function addImages(files) {
                const items = files.map(f => ({
                    picture: URL.createObjectURL(f),
                    file: f
                }));
                return addItems(items);
            }
            function setImages(newImages) {
                localImages = newImages.map((item, index) => ({
                    id: item.id || idCounter++,
                    picture: item.picture,
                    position: index + 1
                }));
                rebuildGroups();
            }
            function setEdgeBlur(edgeBlur) {
                if (edgeBlur) {
                    carousel.classList.add('edge-blur');
                } else {
                    carousel.classList.remove('edge-blur');
                }
            }
            function setSpeed(seconds) {
                currentDuration = seconds;
                updateAnimation();
            }
            function setDirection(direction) {
                currentDirection = direction;
                updateAnimation();
            }
            function setHeight(height) {
                if (height > 0) {
                    currentHeight = height;
                    document.querySelectorAll('.card img').forEach(img => {
                        img.style.height = `${height}px`;
                    });
                    setTimeout(() => {
                        groupWidth = group1?.offsetWidth || 0;
                        updateAnimation();
                    }, 600);
                }
            }
            function pause() {
                animationRunning = false;
                if (track) track.style.animationPlayState = 'paused';
            }
            function play() {
                animationRunning = true;
                if (localImages.length && track) {
                    updateAnimation();
                }
            }
            // Initialize
            buildGroups();
            setTimeout(() => {
                groupWidth = group1?.offsetWidth || 0;
                updateAnimation();
            }, 600);
            window.addEventListener('resize', () => {
                setTimeout(() => {
                    groupWidth = group1?.offsetWidth || 0;
                    updateAnimation();
                }, 600);
            });
            // Controls
            const pauseBtn = document.querySelector('.carousel-pause');
            if (pauseBtn) {
                pauseBtnText();
                pauseBtn.onclick = () => {
                    if (animationRunning) {
                        pause();
                    } else {
                        play();
                    }
                    pauseBtnText();
                };
            }
            const editBtn = document.querySelector('.carousel-edit');
            if (editBtn) {
                const editBtnText = () => {
                    editBtn.textContent = editEnabled ? 'Запретить редактирование' : 'Разрешить редактирование';
                };
                editBtnText();
                editBtn.onclick = () => {
                    editEnabled = !editEnabled;
                    document.querySelectorAll('.card .move-left, .card .move-right, .card .delete').forEach(item => {
                        item.style.display = editEnabled ? 'flex' : 'none';
                    });
                    editBtnText();
                };
            }
            const zoomChk = document.querySelector('.carousel-zoom');
            if (zoomChk) {
                zoomChk.onclick = () => {
                    zoomEnabled = !zoomEnabled;
                };
            }
            const stopOnHoverChk = document.querySelector('.carousel-stop-on-hover');
            if (stopOnHoverChk) {
                stopOnHoverChk.onclick = () => {
                    stopOnHover = !stopOnHover;
                };
            }
            setEdgeBlur(edgeBlur);
            const edgeBlurChk = document.querySelector('.carousel-edge-blur');
            if (edgeBlurChk) {
                edgeBlurChk.onclick = () => {
                    edgeBlur = !edgeBlur;
                    setEdgeBlur(edgeBlur);
                };
            }
            const speedSelect = document.querySelector('.carousel-speed');
            if (speedSelect) {
                speedSelect.value = initialSpeed;
                speedSelect.onchange = () => {
                    setSpeed(parseInt(speedSelect.value));
                };
            }
            const reverseBtn = document.querySelector('.carousel-reverse');
            if (reverseBtn) {
                reverseBtn.onclick = () => {
                    const newDir = currentDirection === 'left' ? 'right' : 'left';
                    setDirection(newDir);
                };
            }
            const heightSelect = document.querySelector('.carousel-height');
            if (heightSelect) {
                heightSelect.value = initialHeight;
                heightSelect.onchange = () => {
                    setHeight(parseInt(heightSelect.value));
                };
            }
            const directionSelect = document.querySelector('.carousel-direction');
            if (directionSelect) {
                directionSelect.value = initialDirection;
                directionSelect.onchange = () => {
                    setDirection(directionSelect.value);
                };
            }
            const urlInput = document.querySelector('.carousel-image-url');
            const addBtn = document.querySelector('.carousel-add-image');
            if (addBtn) {
                addBtn.onclick = () => {
                    const url = urlInput.value.trim();
                    if (!url) return;
                    urlInput.value = '';
                    addImage(url);
                };
            }
            // Multiple images
            const dropZone = document.querySelector('.drop-zone');
            const fileInput = document.querySelector('.file-input');
            const previews = document.querySelector('.previews');
            const addMultipleBtn = document.querySelector('.add-multiple');
            let selectedFiles = [];
            if (dropZone && fileInput && previews && addMultipleBtn) {
                dropZone.addEventListener('click', () => fileInput.click());
                fileInput.addEventListener('change', (e) => {
                    handleFiles(Array.from(e.target.files));
                    fileInput.value = '';
                });
                dropZone.addEventListener('dragover', (e) => {
                    e.preventDefault();
                    dropZone.style.border = '2px dashed blue';
                });
                dropZone.addEventListener('dragleave', () => {
                    dropZone.style.border = '2px dashed gray';
                });
                dropZone.addEventListener('drop', (e) => {
                    e.preventDefault();
                    dropZone.style.border = '2px dashed gray';
                    handleFiles(Array.from(e.dataTransfer.files));
                });
                function handleFiles(files) {
                    const validFiles = files.filter(f => /^image\/(jpeg|png)$/.test(f.type));
                    selectedFiles.push(...validFiles);
                    if (selectedFiles.length) {
                        addMultipleBtn.style.display = 'inline-block';
                        previews.style.display = 'flex';
                    }
                    renderPreviews();
                }
                function renderPreviews() {
                    previews.innerHTML = '';
                    selectedFiles.forEach((f, idx) => {
                        const div = document.createElement('div');
                        div.classList.add('preview-item');
                        const img = document.createElement('img');
                        img.src = URL.createObjectURL(f);
                        div.appendChild(img);
                        const delBtn = document.createElement('button');
                        delBtn.classList.add('delete');
                        delBtn.innerHTML = '<svg class="icon" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>';
                        delBtn.onclick = () => {
                            selectedFiles.splice(idx, 1);
                            if (!selectedFiles.length) {
                                addMultipleBtn.style.display = 'none';
                                previews.style.display = 'none';
                            }
                            renderPreviews();
                            URL.revokeObjectURL(img.src);
                        };
                        div.appendChild(delBtn);
                        previews.appendChild(div);
                    });
                }
                addMultipleBtn.onclick = () => {
                    if (selectedFiles.length) {
                        let success = addImages(selectedFiles);
                        if (!success) {
                            return;
                        }
                        selectedFiles.forEach(f => URL.revokeObjectURL(URL.createObjectURL(f))); // Clean previews
                        selectedFiles = [];
                        renderPreviews();
                        if (!selectedFiles.length) {
                            addMultipleBtn.style.display = 'none';
                            previews.style.display = 'none';
                        }
                    }
                }
                if (!selectedFiles.length) {
                    addMultipleBtn.style.display = 'none';
                    previews.style.display = 'none';
                }
            }
            return {
                addImage,
                moveCard,
                deleteCard,
                setCallbacks: (moveCb, deleteCb) => {
                    onMove = moveCb || onMove;
                    onDelete = deleteCb || onDelete;
                },
                setImages,
                setSpeed,
                setDirection,
                setHeight,
                pause,
                play
            };
        };
        window.createCarousel = createCarousel;
    }
};
export default carousel;
